<template>
  <div>
    <GeneralLink
      v-if="sectionHeading"
      v-bind="sectionHeading"
      :class="{
        'mb-5 border-b border-www-color-neutral-very-light pb-10px text-8px font-bold uppercase tracking-wider md:text-10px': true,
        'block text-www-color-white md:text-www-color-neutral-medium-dark': true,
        'transition duration-300 hover:text-www-color-primary-lighter': sectionHeading.link,
      }"
    />
    <ul
      :class="{
        'pb-2': true,
      }"
      aria-labelledby="subNavItem-Start"
    >
      <li
        v-for="(link, subMenuIndex) in sectionItems"
        :key="subMenuIndex"
        :class="{
          'transition duration-300 hover:text-www-color-primary-lighter': true,
        }"
      >
        <GeneralLink
          _type="generalLink"
          :link="link.link"
          text=""
          :class="{
            'text-www-color-white hover:text-www-color-primary-lighter md:text-www-color-neutral-medium-dark': true,
          }"
        >
          <h3
            :class="{
              'mb-5px text-13px font-bold uppercase tracking-wider': true,
            }"
          >
            {{ link.linkTitle }}
          </h3>
        </GeneralLink>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import type { ProductDropdown } from '~/sanity/types';
import GeneralLink from './GeneralLink.vue';

defineProps<ProductDropdown['modernCad']>();
</script>

<style lang="scss" scoped></style>
